import React,{useEffect,useState} from "react";
import "./HeroBanner.css";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const HeroBanner = ({
  Heading,
  subHeading,
  spanHeading="",
  nextLineSpanHeading,
  Paragraph,
  FullWidthPara=false,
  btnText,
  btnLHS=false,
  bgImg,
  bgVideo=false,
  btn=false,
  btnRef="/",
  socialLinks=false,
  serviceForm=false,
  bgEffect=false,
  heightAuto=false,
  smallHeading=false,
  sideLinks=true,
  homeIcons=false,
  LHStext=false,
  marginBtm=true,
  LHSLogos=false
}) => {
  const navigate = useNavigate()
  const paragraphs = Paragraph.split('\n').map((paragraph, index) => <p key={index} className={`${FullWidthPara?"hero-paragraph-100":"hero-paragraph"} mx-auto`} style={{width:`${FullWidthPara?"100%":"80%"}`}}>{paragraph}</p>);
  return (
    <div
      className={`common_hero_section ${bgVideo && "bg-video"} ${heightAuto && "h-cus-auto"} ${marginBtm && "mb-5"}`}
      style={{ backgroundImage: `url(${bgImg})`}}
        
    >
      <div className={`${bgEffect && "bg-effect"} h-100`}>
       { bgVideo && <video autoPlay loop muted>
        <source src="./images/backgroundVideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>}

      <div className="hero-container h-100  px-0"
      
      >
     <div className="wrapper d-flex flex-column pt-xl-3 pt-0">

      <Header/>
      <div 
        className={` d-flex align-items-center ${LHSLogos && "minH80"}  ${homeIcons ?"h-100 pt-5 pb-2 mt-5":"my-auto py-5"} container`}
        >

        {sideLinks &&
        
        <div className="d-flex flex-column justify-content-center align-items-center gap-3">
          <h3 className="verticle-text" style={{color:"white"}}>SCROLL</h3>
          <div className="" style={{border:"1.5px solid white", width:"0" , height:"100px" }}></div>
        </div>
        }

        <div className={`gy-2 w-100 ${homeIcons && "h-100 "} `}>
          <div
            className={
              serviceForm
                ? "col-md-6 "
                : "col-12 hero_content_wrapper px-3 w-100"
            }
          >
            <div className={`hero-text-content w-100 text-center ${homeIcons && "h-100 d-flex flex-column justify-content-between align-items-center"}`}>
              <div className={`${homeIcons && "h-100 d-flex flex-column justify-content-center align-items-center "}`}>
           {subHeading && <h5 className="hero-sub-heading">{subHeading}</h5>}
           {LHStext && <p className="px-3 py-1 mx-auto mb-4" style={{background:"rgba(255, 255, 255, 0.383)",width:"max-content",borderRadius:"50px",color:"white"}}>RESA® Designation Course</p>}
            <h1 className={`hero-section-heading my-3 ${smallHeading && "hero-section-heading-small"}`}>
              {Heading}
              <span className="" style={{textTransform:"none"}}>{spanHeading}</span>
              {nextLineSpanHeading && <><br/> <span className="" style={{textTransform:"none"}}>{nextLineSpanHeading}</span></>}
            </h1>
            {Paragraph && <p className={`${FullWidthPara?"hero-paragraph-100":"hero-paragraph"} mx-auto`}>{paragraphs}</p>}
            {LHStext && <p className={`${FullWidthPara?"hero-paragraph-100":"hero-paragraph"} mx-auto pt-4`}>3 hours &nbsp;&nbsp; RESA-CSA™ designation &nbsp;&nbsp; In-person or virtual</p>}
            {btn && <button className="genral-btn mt-4" onClick={()=>{navigate(btnRef)}}>{btnText}</button>}
            {btnLHS &&
            <div className="d-flex flex-lg-row flex-column align-items-center justify-content-center gap-lg-3 gap-1">
              {/* <button className="genral-btn mt-4" onClick={()=>{navigate("/contact")}}>Book a Consultation</button> */}
              <button className="genral-btn mt-4" onClick={()=>{window.open("tel:(437) 998-6650")}}>Book a session for your team</button>
            </div> 
            }
           </div>

            {
              homeIcons && !LHSLogos &&
              <div className="row pt-5 w-100 mt-auto">
                 <Swiper
            spaceBetween={50}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Autoplay]}
            breakpoints={{
                200:{
                  slidesPerView: 1,
                },
                550: {
                  slidesPerView: 2,
                },
                800: {
                  slidesPerView: 5,
                },
              }}
            className="mx-auto"
            >

                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-25.png" alt="partner icon" style={{maxWidth:"200px"}} />
                </SwiperSlide>
                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-26.png" alt="partner icon" style={{maxWidth:"280px"}} />
                </SwiperSlide>
                 <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-27.png" alt="partner icon" style={{maxWidth:"150px"}} />
                </SwiperSlide>
                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-28.png" alt="partner icon" style={{maxWidth:"280px"}} />
                </SwiperSlide>
                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/home-banner-1.png" alt="partner icon" style={{maxWidth:"180px"}} />
                </SwiperSlide>

                  <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-25.png" alt="partner icon" style={{maxWidth:"200px"}} />
                </SwiperSlide>
                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-26.png" alt="partner icon" style={{maxWidth:"280px"}} />
                </SwiperSlide>
                 <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-27.png" alt="partner icon" style={{maxWidth:"150px"}} />
                </SwiperSlide>
                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/sponsor-logo-28.png" alt="partner icon" style={{maxWidth:"280px"}} />
                </SwiperSlide>
                <SwiperSlide className="d-flex align-items-center justify-content-center">
                <img src="/images/icons/home-banner-1.png" alt="partner icon" style={{maxWidth:"180px"}} />
                </SwiperSlide>


            </Swiper>
              </div>
            }
            {
              LHSLogos &&
              <div className="row pt-5 w-100 mt-auto">
                
                <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between gap-5">
                <img src="/images/icons/LHS-logo-1.png" alt="partner icon" style={{maxWidth:"250px"}} />
                <img src="/images/icons/LHS-logo-2.png" alt="partner icon" style={{maxWidth:"250px"}} />
                </div>
               
                
              </div>
            }
            
          </div>
          </div>
          {serviceForm && (
            <div className="col-md-6 pb-5">
              <div className="service-form d-flex flex-column px-5 py-5">
                <h3 className="body-heading" style={{ color: "black" }}>
                  Let’s get in touch!
                </h3>
                <p
                  className="body-paragraph text-start"
                  style={{ color: "black" }}
                >
                  Let’s discuss your project and find out what we
                </p>
                <input type="text" placeholder="Your Full Name" />
                <input type="text" placeholder="Your Email Address" />
                <input type="text" placeholder="Phone Number" />
                <input type="text" placeholder="Your Message" />
                <button className="service-from-btn  blue-btn">Submit</button>
              </div>
            </div>
          )}
        </div>
        {
        sideLinks &&
          <div className="d-flex flex-column justify-content-center align-items-center gap-3">
            <div className="icon-container d-flex flex-column align-items-center gap-3">
              <a 
                href="https://www.facebook.com/meadowsequine/"
                target="blank"  
              >
                <img src="/images/icons/hero-fb-icon.svg" alt="icon"/>
              </a>

              <a 
                href="https://www.instagram.com/meadows.equine/"
                target="blank"  
              >
                <img src="/images/icons/hero-insta-icon.svg" alt="icon"/>
              </a>
            </div>
            <div className="" style={{border:"1.5px solid white", width:"0" , height:"120px" }}></div>
          </div>
        }
      </div>
      </div>
      </div>
      </div>
    </div>
  );
};

export default HeroBanner; 